const DOCS_BASE_URL = 'https://docs.outpoll.com';
const FUTURES_GUIDE_URL = `${DOCS_BASE_URL}/future-trading-guide`;
const FUTURES_EXPLAINED_URL = `${FUTURES_GUIDE_URL}/futures-trading-explained`;
const FUTURES_ORDER_TYPES_URL = `${FUTURES_GUIDE_URL}/orders-and-positions/order-types-limit-and-market`;
const FUTURES_POSITIONS_URL = `${FUTURES_GUIDE_URL}/orders-and-positions/positions-manage-executed-orders`;
const FUTURES_LEVERAGE_URL = `${FUTURES_GUIDE_URL}/orders-and-positions/leverage-and-liquidation`;

export const DOCS_URL = {
  home: `${DOCS_BASE_URL}/`,
  apiIntroduction: `${DOCS_BASE_URL}/api/introduction`,
  termsOfService: `${DOCS_BASE_URL}/terms/terms-of-service`,
  privacyPolicy: `${DOCS_BASE_URL}/terms/privacy-policy`,
  cookiePolicy: `${DOCS_BASE_URL}/terms/cookie-policy`,
  outpollToken: `${DOCS_BASE_URL}/getting-started/outpoll-token`,
  passkeys: `${DOCS_BASE_URL}`,
  futuresContractTypes: `${FUTURES_EXPLAINED_URL}#contract-types`,
  futuresPrices: `${FUTURES_EXPLAINED_URL}#prices-you-will-see`,
  futuresFunding: `${FUTURES_GUIDE_URL}/trading-conditions/funding`,
  futuresBonuses: `${FUTURES_GUIDE_URL}/trading-conditions/bonuses`,
  futuresOrderTypes: FUTURES_ORDER_TYPES_URL,
  futuresOrderOptions: `${FUTURES_ORDER_TYPES_URL}#order-options`,
  futuresOrderAmount: `${FUTURES_ORDER_TYPES_URL}#how-much-to-trade`,
  futuresTpSl: `${FUTURES_GUIDE_URL}/orders-and-positions/take-profit-and-stop-loss`,
  futuresPositionColumns: `${FUTURES_POSITIONS_URL}#position-columns`,
  futuresClosePosition: `${FUTURES_POSITIONS_URL}#closing-a-position`,
  futuresHistory: `${FUTURES_POSITIONS_URL}#history`,
  futuresBalance: `${FUTURES_LEVERAGE_URL}#your-balance`,
  futuresLiquidation: `${FUTURES_LEVERAGE_URL}#liquidation`,
  futuresMarginCall: `${FUTURES_LEVERAGE_URL}#margin-call-warnings-cross`,
  futuresErrors: `${FUTURES_GUIDE_URL}/faq#common-error-messages`,
} as const;
